<template>
  <div class="teacher-work-box teacher-work-bg">

    <header class="flex-align-between teacher-head">
      <div class="flex-align-center title-box">
        <img alt="" class="ico" src="@/assets/teacher/h1-title-ico.png">
        <span class="text">投影与测评</span>
      </div>

      <div class="flex-align-center right-button">
        <div class="flex-align-center test-button-box" @click="jumpPage">
          <img alt="" class="ico" src="@/assets/teacher/button-test-ico.png">
          <span class="text">班级同步测评</span>
        </div>
        <div class="flex-align-center back-box" @click="goBack">
          <img alt="" class="back-ico" src="@/assets/teacher/back-ico.png">
          <span class="back-text">返回</span>
        </div>
      </div>
    </header>

    <div class="content-box flex-column-center">

        <div class="code-page-tips">
          <div class="s-title">提示：</div>
          <div class="s-cont flex-align">
            <span>教师登录“优字教师端小程序”后，点击</span>
            <img alt="" class="ico" src="@/assets/teacher/camera.png">
            <span>同步投影 使用</span>
          </div>
        </div>

        <div class="code-block flex-align-center">
          <img alt="" class="img" src="@/assets/teacher/code.png">
          <div class="text">
            微信扫描二维码，<br/> 打开小程序
          </div>
        </div>
        <div class="code-text">注意：小程序和电脑端要使用同一账号</div>

    </div>



  </div>
</template>

<script>
export default {
  data() {
    return {
      writeCount: null,
    };
  },
  components: {
  },
  //方法
  methods: {
    goBack() {
      if (this.$router && typeof this.$router.back === 'function') {
        this.$router.back();
      } else {
        window.history.back();
      }
    },
    jumpPage() {
      if (this.$router) {
        const targetByName = { name: 'classSelection' };
        try {
          const resolved = this.$router.resolve(targetByName);
          if (resolved && resolved.route && resolved.route.matched && resolved.route.matched.length > 0) {
            this.$router.push(targetByName);
          } else {
            this.$router.push('/classSelection');
          }
        } catch (e) {
          this.$router.push('/classSelection');
        }
      }
    },
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {

  },
};
</script>
<style lang='less' scoped>
@import "./less/classTestMain.less";
</style>
